export default "__VITE_ASSET__9b34184f__"